// extracted by mini-css-extract-plugin
export default {"container":"createPackage_container__YC0-w"};